import React, { useEffect } from "react";
import { connect } from "react-redux";
import ReactGA from "react-ga4";
import { get, includes } from "lodash";
import AccountingVouchersContainer from "./AccountingVouchersContainer";

const VouchersContainer = (props) => {
    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: "/vouchers", title: "Vouchers" });
    }, []);

    return includes(["accounting"], get(props.userProfile, "role", null)) && <AccountingVouchersContainer {...props} />;
};

const mapStateToProps = (state) => {
    return {
        userProfile: state.authReducer.userProfile,
        role: state.authReducer.userProfile.role,
        user: state.authReducer.userProfile.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(VouchersContainer);
